import React, { createContext, useContext, useReducer, useCallback } from 'react';

const AppContext = createContext(null);

const initialState = {
  currentUser: null,
  inventory: [],
  transactions: [],
  suppliers: [],
  settings: {},
  currentPage: 'dashboard',
  sidebarOpen: true,
  loading: false,
};

function reducer(state, action) {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, currentUser: action.payload };
    case 'LOGOUT':
      return { ...initialState };
    case 'SET_INVENTORY':
      return { ...state, inventory: action.payload };
    case 'SET_TRANSACTIONS':
      return { ...state, transactions: action.payload };
    case 'SET_SUPPLIERS':
      return { ...state, suppliers: action.payload };
    case 'SET_SETTINGS':
      return { ...state, settings: action.payload };
    case 'SET_PAGE':
      return { ...state, currentPage: action.payload };
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarOpen: !state.sidebarOpen };
    case 'SET_SIDEBAR':
      return { ...state, sidebarOpen: action.payload };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const login       = useCallback((user) => dispatch({ type: 'LOGIN', payload: user }), []);
  const logout      = useCallback(() => dispatch({ type: 'LOGOUT' }), []);
  const setInventory    = useCallback((data) => dispatch({ type: 'SET_INVENTORY', payload: data }), []);
  const setTransactions = useCallback((data) => dispatch({ type: 'SET_TRANSACTIONS', payload: data }), []);
  const setSuppliers    = useCallback((data) => dispatch({ type: 'SET_SUPPLIERS', payload: data }), []);
  const setSettings     = useCallback((data) => dispatch({ type: 'SET_SETTINGS', payload: data }), []);
  const setPage         = useCallback((page) => dispatch({ type: 'SET_PAGE', payload: page }), []);
  const toggleSidebar   = useCallback(() => dispatch({ type: 'TOGGLE_SIDEBAR' }), []);
  const setSidebar      = useCallback((open) => dispatch({ type: 'SET_SIDEBAR', payload: open }), []);
  const setLoading      = useCallback((val) => dispatch({ type: 'SET_LOADING', payload: val }), []);

  return (
    <AppContext.Provider value={{
      ...state,
      login, logout,
      setInventory, setTransactions, setSuppliers, setSettings,
      setPage, toggleSidebar, setSidebar, setLoading,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
}
